module.exports = __webpack_public_path__ + "static/media/2.8df2f8a3.jpg";